import React, { useState, useEffect } from 'react'
import SubHeader from '../../components/Shared/SubHeader/SubHeader'
import { SelectChangeEvent } from '@mui/material';

import ExportButton from '../../components/Shared/ExportButton/ExportButton';
import SearchBar from '../../components/Shared/SearchBar/SearchBar';
import PaginationInfo from '../../components/Shared/Pagination/PaginationInfo';
import PurchaseHistoryTable from '../../components/Shared/PurchaseHistoryTable/PurchaseHistoryTable';
import Pagination3 from '../../components/Shared/Pagination/Pagination3';
import { Transaction, TransactionItem, TransactionsResponse, TransactionsService } from '../../services/TransactionsService';
import { FetchAuth } from '../../utils/FetchAuthUtil';
import { GradesDTO } from '../../dto/GradesDTO';

 
  

 

const columns = [
    "Order ID",
    "User Name",
    "Email Address",
    "Total Price($)",
    "Purchase Date",
    "Status"
]
const Innercolumns = [
    "Book",
    'Grades',
    "Quantity",
    "Price($)"
]

const columnKeyMapping: { [key: string]: string } = {
    'Order ID': '_id',
    'User Name': 'name',
    'Email Address': 'email',
    'Total Price($)': 'totalPrice',
    'Purchase Date': 'orderDate',
    'Status': 'status'
};

function Transactions() {
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
    const [transactions, setTransactions] = useState<Transaction[]>([]);

    const fetchTransactions = async () => {
        try {
            setLoading(true);
            const data = await TransactionsService.getTransactions(
                currentPage,
                pageSize,
                searchTerm,
                sortColumn,
                sortDirection
            ) as TransactionsResponse;
            console.log(data)
            setTransactions(data.data?.orders || []);
            setTotal(data.data?.total || 0);
        } catch (error) {
            console.error('Error fetching transactions:', error);
            setTransactions([]);
            setTotal(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactions();
    }, [currentPage, pageSize, searchTerm, sortColumn, sortDirection]);

    const formatDate = (oldDate: string): string => {
        if (!oldDate) {
            return " ";
        }

        const date = new Date(oldDate);
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();

        return `${day}, ${month} ${year}`;
    };

    const handleSearchChange = (value: string) => {
        setCurrentPage(1);
        setSearchTerm(value);
    };

    const handleView = () => {
        // Implement view functionality if needed
    };

    const handlePageSizeChange = (event: SelectChangeEvent<unknown>) => {
        setCurrentPage(1);
        setPageSize(Number(event.target.value));
    };

    const handleSort = (column: string) => {
        const backendKey = columnKeyMapping[column];
        if (!backendKey) return;
        if (loading) return;

        if (sortColumn === backendKey) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(backendKey);
            setSortDirection('asc');
        }
    };

    const handlePageChange = (page: number): void => {
        setCurrentPage(page);
    };

    const handleDownloadReceipt = async (orderId: string) => {
        try {
            const response = await FetchAuth(`${process.env.REACT_APP_API_ENDPOINT}/order/downloadReciept/${orderId}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/pdf',
                }
            });

            if (!response.ok) {
                throw new Error('Failed to download receipt');
            }

            const blob = await response.blob();
            
            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `receipt-${orderId}.pdf`);
            link.setAttribute('type', 'application/pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading receipt:', error);
        }
    };

    const formatTransactionData = (transaction: Transaction) => {
        return {
            "Order ID": transaction._id,
            "User Name": transaction.userId?.fullname || 'N/A',
            "Email Address": transaction.userId?.email || 'N/A',
            "Total Price($)": transaction.totalAmount,
            "Purchase Date": formatDate(transaction.orderDate),
            "Status": transaction.status,
            "items": transaction.items.map((item: TransactionItem) => ({
                "Book": item.book.bookTitle,
                "Quantity": item.quantity,
                "Price($)": item.purchasedPrice,
                "Grades":item.book?.grades,
            }))
        };
    };

    return (
        <>
            <div>
                <div className='w-full flex items-center justify-between py-[34px]'>
                    <div className='flex-1'>
                        <SearchBar searchTerm={searchTerm} onSearch={handleSearchChange} />
                    </div>
                    <div className='flex gap-[24px]'>
                        <PaginationInfo 
                          totalItems={total} 
                          pageSize={pageSize}
                          currentPage={currentPage}
                          handlePageSizeChange={handlePageSizeChange}
                        />
                        <ExportButton label="Export" exportType="transactions" />
                    </div>
                </div>
                <div>
                    <PurchaseHistoryTable 
                        columns={columns} 
                        books={transactions} 
                        Innercolumns={Innercolumns} 
                        data={transactions.map(formatTransactionData)} 
                        onView={handleView} 
                        loading={loading} 
                        handleSort={handleSort} 
                        sortColumn={sortColumn} 
                        sortDirection={sortDirection} 
                        handleDownloadReceipt={handleDownloadReceipt}
                    />
                </div>
                <Pagination3 
                    totalPages={Math.ceil(total / pageSize)} 
                    currentPage={currentPage} 
                    onPageChange={handlePageChange} 
                />
            </div>
        </>
    )
}

export default Transactions




